import { useOrderImportBasicFeatureGate } from './use-order-import-basic-feature-gate';
import { useOrderImportCustomStoreFeatureGate } from './use-order-import-custom-store-feature-gate';
import { useExternalStoresAccessFeatureGate } from './use-external-stores-access-feature-gate';

/**
 * Custom hook to check if the Orders Grid is enabled.
 * @returns {boolean} - Returns true if the Orders Grid feature is enabled, false otherwise.
 */
export const useIsOrdersGridEnabled = () => {
  const { isFeatureEnabled: hasOrderImportBasic } = useOrderImportBasicFeatureGate();
  const { isFeatureEnabled: hasOrderImportCustomStore } = useOrderImportCustomStoreFeatureGate();
  const { isFeatureEnabled: hasExternalStoresAccess } = useExternalStoresAccessFeatureGate();

  // if seller has any of these features enabled, the Orders Grid should be enabled
  return hasOrderImportBasic || hasOrderImportCustomStore || hasExternalStoresAccess;
};
